import apiClient from './base/apiClient'

export type InquiryStatus = 'open' | 'answered' | 'closed'

export interface InquiryCategory {
  id: string
  label: string
}

export interface InquirySummary {
  id: number
  category: string
  category_label: string
  subject: string
  status: InquiryStatus
  created_at: string
  updated_at: string
}

export interface InquiryMessage {
  id: number
  sender: 'user' | 'admin'
  /** 사용자 쪽은 아이디 그대로, 운영자 쪽은 'TASTEE'. 서버가 정해서 내려준다. */
  author: string
  body: string
  /** 첨부 사진 주소(없으면 빈 배열) */
  photos?: string[]
  created_at: string
}

export interface InquiryListResponse {
  items: InquirySummary[]
  categories: InquiryCategory[]
}

export interface InquiryDetailResponse {
  inquiry: InquirySummary
  messages: InquiryMessage[]
}

export interface CreateInquiryPayload {
  category: string
  subject?: string
  body: string
  /** 미리 올린 사진 주소(선택, 최대 5장) */
  photos?: string[]
}

/**
 * 앱 버전·플랫폼은 보내지 않는다.
 * apiClient 가 이미 X-App-Version 헤더로 싣고 있고, 서버가 users 행에서 집어 쓴다.
 */
export const inquiryApi = {
  getInquiries: async (): Promise<InquiryListResponse> => {
    const response = await apiClient.get<InquiryListResponse>('/inquiries')
    return response.data
  },

  getInquiry: async (id: number): Promise<InquiryDetailResponse> => {
    const response = await apiClient.get<InquiryDetailResponse>(`/inquiries/${id}`)
    return response.data
  },

  createInquiry: async (payload: CreateInquiryPayload): Promise<{ id: number }> => {
    const response = await apiClient.post<{ id: number }>('/inquiries', payload)
    return response.data
  },

  addMessage: async (id: number, body: string): Promise<void> => {
    await apiClient.post(`/inquiries/${id}/messages`, { body })
  },
}

export const INQUIRY_STATUS_LABEL: Record<InquiryStatus, string> = {
  open: '답변 대기',
  answered: '답변 완료',
  closed: '종료',
}
